import { useState, useCallback } from 'react';
import { DropdownItem, FilterItem, Searchbar, TOption } from '@treezor/design-system';

import { RenderSelectedValues } from '@/ui-kit/table-filters/RenderSelectedValues';
import { ILookupField } from '@/ui-kit/table-filters/filters.type';
import { DashboardHelpers } from '@/utils/DashboardHelpers';

export interface ILookupFilterProps {
  field: ILookupField;
  label?: string;
  isFilled?: boolean;
  className?: string;
  testId?: string;
}

export function LookupFilter({ field, label, isFilled = true, className, testId }: ILookupFilterProps) {
  const [lookupList, setLookupList] = useState<TOption[]>(field?.options || []);

  const onLookup = useCallback(
    (value) => {
      if (!field?.options?.length) {
        field.handleChange(value);
        return;
      }

      if (value === '') {
        setLookupList([]);
        return;
      }

      const options = field?.options?.filter(({ label, value: optionValue }) => {
        return [label, optionValue].some((item) => item.toString().toLowerCase().includes(value.toLowerCase()));
      });

      setLookupList(options);
    },
    [field],
  );

  return (
    <FilterItem
      type="CUSTOM"
      id="lookup"
      renderSelectedValues={(closeDropDown) => (
        <RenderSelectedValues
          label={label}
          values={!!field?.value ? [field.value as string] : undefined}
          onReset={
            isFilled
              ? () => {
                  closeDropDown();
                  field.handleChange(null);
                }
              : undefined
          }
        />
      )}
      testId={testId}
      dropdownContent={(closeDropDown) => (
        <div className="flex flex-col py-3">
          <Searchbar
            type="text"
            size="s"
            className="w-full px-4 py-2"
            withSearchButton={!field?.options?.length}
            onChange={onLookup}
            defaultValue={field?.value as string}
          />
          {lookupList?.length > 0 &&
            lookupList.map((option) => (
              <DropdownItem
                key={`option-${option.value}`}
                label={`${option.value}: ${DashboardHelpers.truncateText(option.label as string, 30)}`}
                onClick={() => {
                  field.handleChange(option.value);
                  closeDropDown();
                }}
                testId={`dropdown-item-${option.value}`}
              />
            ))}
        </div>
      )}
      className={className}
    />
  );
}
